<template>
  <div id="contenedor-contrato-catalogo">
    <v-row align="center" no-gutters class="mb-2" justify="space-between">
      <v-col cols="12" md="6">
        <v-row v-if="!$apollo.loading" no-gutters>
          <v-col cols="6" md="auto">
            <v-card flat class="mr-2">
              <v-card-title class="py-1">{{ getTotalContratado | currency }}</v-card-title>
              <v-card-subtitle>
                <template
                  v-if="!contrato.esObraFinanciada">
                  Importe Contratado
                </template>
                <template
                  v-else>
                  Costo directo
                </template>
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="6" md="auto">
            <v-card
              flat
              :color="getTotalContratado === getTotalCatalogo ? 'success' : 'warning'"
              dark>
              <v-card-title class="py-1">{{ getTotalCatalogo | currency }}</v-card-title>
              <v-card-subtitle>
                <span
                  class="mt-2">
                  Importe Catálogo
                </span>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <!-- ToolBar -->
        <tool-bar
          v-if="getCatalogoConceptos.length > 0 && !soloLectura"
          v-on:cargarCatalogo="cargarCatalogo"
          v-on:actualizarCatalogo="seGuardoCatalogo"
          v-on:exportarCatalogo="exportarCatalogo"
          v-on:agregarPartida="agregarPartida"
          v-on:borrarCatalogo="borrarCatalogo"
          :catalogoConceptos="getCatalogoConceptos"
          :contrato="getContrato"
        ></tool-bar>
      </v-col>
    </v-row>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody">
    </v-skeleton-loader>
    <!-- Guardar/Cargar catalogo -->
    <cargar-catalogo
      v-if="contrato"
      :cargar="seCargaraCatalogo"
      v-on:seCargoVistaPreviaCatalogo="seCargoVistaPreviaCatalogo"
      v-on:seGuardoCatalogo="seGuardoCatalogo"
      :contrato="contrato"
    ></cargar-catalogo>
    <!-- Si no hay catalogo mostrar boton -->
    <v-card
      class="mt-4 grey lighten-3"
      flat
      v-if="!$apollo.loading && getCatalogoConceptos.length <= 0"
    >
      <v-card-text>
        <v-row justify="center">
          <v-col cols="4">
            <custom-button
              v-if="mixValidaScopesActions(1)"
              class="mr-2"
              label="cargar catálogo"
              iconText="mdi-file-import"
              tipo="agregar"
              @click="cargarCatalogo">
            </custom-button>
            <custom-button
              v-if="mixValidaScopesActions(1)"
              label="Agregar Partida"
              iconText="mdi-plus"
              tipo="agregar"
              @click="agregarPartida">
            </custom-button>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Mostrar catalogo -->
    <v-card flat>
      <v-card-text>
        <catalogo
          v-if="getCatalogoConceptos.length > 0
          && !seCargoVistaPrevia && !$apollo.loading"
          :catalogo="getCatalogoConceptos"
          :solo-lectura="soloLectura">
        </catalogo>
      </v-card-text>
    </v-card>
    <v-dialog
      v-if="esteCatalogoConcepto"
      v-model="mostrarVentanaEliminarConceptoCatalogo"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'"
    >
      <eliminar-concepto-catalogo
        :catalogoConceptoEliminar="esteCatalogoConcepto"
        v-on:cerrar="cerrarVentana"
      ></eliminar-concepto-catalogo>
    </v-dialog>
    <!-- Ventana eliminar catalogo completo -->
    <v-dialog
      v-if="mostrarVentanaEliminarCatalogo"
      v-model="mostrarVentanaEliminarCatalogo"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'"
    >
      <eliminar-catalogo
        :idContrato="idContrato"
        v-on:actualizarCatalogo="seGuardoCatalogo"
        v-on:cerrar="cerrarVentana"
      ></eliminar-catalogo>
    </v-dialog>
    <v-dialog
      v-if="esteTipoConcepto"
      v-model="mostrarVentanaAgregarConceptoCatalogo"
      :width="!$vuetify.breakpoint.mobile ? '650' : '90%'"
    >
      <agregar-concepto-catalogo
        :tipoConcepto="esteTipoConcepto"
        :catalogo="getCatalogoConceptos"
        v-on:cerrar="cerrarVentana"
      ></agregar-concepto-catalogo>
    </v-dialog>
    <v-dialog
      v-if="esteCatalogoConcepto"
      v-model="mostrarVentanaEditarConceptopCatalogo"
      :width="!$vuetify.breakpoint.mobile ? '650' : '90%'"
      persistent
    >
      <editar-concepto-catalogo
        :catalogoConceptoEditar="esteCatalogoConcepto"
        :partidas="getCatalogoSoloPartidas"
        v-on:cerrar="cerrarVentana"
      ></editar-concepto-catalogo>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptos.gql';
import CustomButton from '@/components/buttons/Button.vue';
import CargarCatalogo from '@/components/administracion/contratos/contrato/catalogo/Cargar.vue';
import AgregarConceptoCatalogo from '@/components/administracion/contratos/contrato/catalogo/Nuevo.vue';
import EditarConceptoCatalogo from '@/components/administracion/contratos/contrato/catalogo/Editar.vue';
import EliminarConceptoCatalogo from '@/components/administracion/contratos/contrato/catalogo/Eliminar.vue';
import EliminarCatalogo from '@/components/administracion/contratos/contrato/catalogo/EliminarCatalogo.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Catalogo from './Catalogo.vue';

export default {
  name: 'ContratoCatalogo',
  components: {
    ToolBar,
    CustomButton,
    Catalogo,
    CargarCatalogo,
    AgregarConceptoCatalogo,
    EliminarConceptoCatalogo,
    EditarConceptoCatalogo,
    EliminarCatalogo,
  },
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      uploadProgress: 0,
      seCargaraCatalogo: false,
      seCargoVistaPrevia: false,
      mostrarVentanaAgregarConceptoCatalogo: false,
      mostrarVentanaEliminarConceptoCatalogo: false,
      mostrarVentanaEditarConceptopCatalogo: false,
      mostrarVentanaEliminarCatalogo: false,
      esteCatalogoConcepto: null,
      esteTipoConcepto: null,
      idContrato: this.$route.params.idContrato,
    };
  },
  mounted() {
    eventBus.$on('eliminar-catalogo-concepto', (catalogoConcepto) => {
      this.esteCatalogoConcepto = catalogoConcepto;
      this.mostrarVentanaEliminarConceptoCatalogo = true;
    });
    eventBus.$on('editar-catalogo-concepto', (catalogoConcepto) => {
      this.esteCatalogoConcepto = catalogoConcepto;
      this.mostrarVentanaEditarConceptopCatalogo = true;
    });
    eventBus.$on('agregar-sub-partida-catalogo', (catalogoConcepto) => {
      this.esteTipoConcepto = {
        tipo: 1,
        idPadre: catalogoConcepto.id,
        idContrato: catalogoConcepto.idContrato,
        orden: catalogoConcepto.orden,
      };
      this.mostrarVentanaAgregarConceptoCatalogo = true;
    });
    eventBus.$on('agregar-catalogo-concepto', (catalogoConcepto) => {
      this.esteTipoConcepto = {
        tipo: 2,
        idPadre: catalogoConcepto.id,
        idContrato: catalogoConcepto.idContrato,
        orden: catalogoConcepto.orden,
      };
      this.mostrarVentanaAgregarConceptoCatalogo = true;
    });
  },
  methods: {
    agregarPartida() {
      this.esteTipoConcepto = { tipo: 0, idPadre: '', idContrato: this.idContrato };
      this.mostrarVentanaAgregarConceptoCatalogo = true;
    },
    // agregarSubPartida(partidaPadre) {
    //   this.esteTipoConcepto = { tipo: 1, idPadre: partidaPadre, idContrato: this.idContrato };
    //   this.mostrarVentanaAgregarConceptoCatalogo = true;
    // },
    // agregarConcepto(partidaPadre) {
    //   this.esteTipoConcepto = { tipo: 2, idPadre: partidaPadre, idContrato: this.idContrato };
    //   this.mostrarVentanaAgregarConceptoCatalogo = true;
    // },
    borrarCatalogo() {
      console.log('paso2');
      this.mostrarVentanaEliminarCatalogo = true;
    },
    cargarCatalogo() {
      this.seCargaraCatalogo = !this.seCargaraCatalogo;
    },
    seCargoVistaPreviaCatalogo(seCargo) {
      this.seCargoVistaPrevia = seCargo;
    },
    exportarCatalogo() {},
    seGuardoCatalogo() {
      this.seCargoVistaPrevia = false;
      this.$apollo.queries.contratoCatalogoConceptos.refetch();
    },
    cerrarVentana() {
      this.mostrarVentanaAgregarConceptoCatalogo = false;
      this.mostrarVentanaEliminarConceptoCatalogo = false;
      this.mostrarVentanaEditarConceptopCatalogo = false;
      this.mostrarVentanaEliminarCatalogo = false;
      this.esteCatalogoConcepto = null;
      this.esteTipoConcepto = null;
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    importeContrato() {
      if (!this.contrato) return 0;
      if (this.contrato.esObraFinanciada) {
        return this.contrato.importeCostoDirecto;
      }
      return this.contrato.importe;
    },
    getTotalContratado() {
      if (!this.contrato) return 0;
      return this.importeContrato + this.getContratoImporteModificado;
    },
    getContratoImporteModificado() {
      if (this.contrato.esObraFinanciada) {
        return this.contrato.modificado.importeCostoDirecto;
      }

      return this.contrato.modificado.importe;
    },
    getCatalogoConceptos() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos;
    },
    getCatalogoSoloPartidas() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos
        .filter(({ tipo }) => tipo === 0 || tipo === 1)
        .map((concepto) => ({
          ...concepto,
          conceptoModificado: `${concepto.clave} - ${concepto.concepto} - ${concepto.orden}`,
        }))
        .sort((a, b) => a.orden - b.orden);
    },
    getTotalCatalogo() {
      if (!this.contratoCatalogoConceptos) return 0;
      const soloConceptos = this.contratoCatalogoConceptos.filter(
        (concepto) => concepto.tipo === 2,
      );

      return this.$ObjSumar(soloConceptos, 'importe');
    },
  },
};
</script>

<style lang="scss">
</style>
